export const SITE_NAME = "catalojei"

export const SITE_URL = (import.meta.env.VITE_SITE_URL || "https://catalojei.com.br/").replace(/\/$/, "")

export const DEFAULT_OG_IMAGE = "/logo600.png"

export const DEFAULT_SEO_DESCRIPTION =
  "Crie sua loja virtual, cadastre produtos, receba pedidos, emita cupom fiscal (NFC-e) e venda pela internet com uma plataforma simples para pequenos negócios começarem online."

export const SEO_KEYWORDS = [
  "criar loja virtual",
  "criar loja online",
  "loja virtual",
  "loja online",
  "loja virtual grátis",
  "criar loja virtual grátis",
  "montar loja virtual",
  "montar loja online",
  "abrir loja virtual",
  "plataforma de e-commerce",
  "plataforma ecommerce",
  "plataforma de loja virtual",
  "sistema de loja virtual",
  "sistema para loja online",
  "vender online",
  "vender pela internet",
  "vender produtos online",
  "começar a vender online",
  "site de vendas online",
  "criar site de vendas",
  "criar loja para vender online",
  "plataforma para vender online",
  "plataforma para pequenos negócios",
  "loja virtual para pequenos empreendedores",
  "catálogo online com pedidos",
  "loja com pagamento online",
  "loja virtual com checkout",
  "loja virtual com link próprio",
  "loja online sem complicação",
  "cadastrar produtos",
  "receber pedidos",
  "pagamento online",
  "link da loja",
  "loja própria",

  // cupom fiscal / nota fiscal
  "cupom fiscal para loja virtual",
  "emissão de cupom fiscal",
  "sistema com emissão de NFC-e",
  "NFC-e para loja virtual",
  "nota fiscal para loja online",
  "sistema fiscal para pequenos negócios",
  "loja virtual com cupom fiscal",
  "importar nota fiscal de compra",
]

export const SUPPORTED_LOCALES = ["pt-BR"]

export const SEARCH_CONSOLE_VERIFICATION = import.meta.env.VITE_GOOGLE_SITE_VERIFICATION || ""
